const defaultConfig = require('./config.json');

const extent = function (dict, additional) {
    if (additional) {
        return {
            ...dict,
            ...additional
        };
    }

    return {
        ...dict
    };
};

const fromConfig = (commonConfig, config, name) => {
    let response = {};

    response = extent(response, defaultConfig[name]);
    response = extent(response, commonConfig[name]);
    response = extent(response, config[name]);

    return response;
};

module.exports = (commonConfig, config) => {
    return {
        pagination : fromConfig(commonConfig, config, 'pagination'),
        forms      : fromConfig(commonConfig, config, 'forms'),
        custom     : fromConfig(commonConfig, config, 'custom')
    };
};
